<template>
  <a-segmented
    ref="segmentedRef"
    v-bind="attrs"
    :class="[
      bem.b(),
      useHover ? bem.is('use-hover') : '',
      bem.is(checkedStyle === 'blue' ? 'blue-style' : 'white-style'),
    ]"
  >
    <template v-if="$slots.label" #label="data">
      <slot name="label" v-bind="data"></slot>
    </template>
    <template v-else #label="data">
      <ll-icon v-if="data?.payload?.icon" :icon-name="data?.payload?.icon" />
      {{ data.title }}
    </template>
  </a-segmented>
</template>

<script setup lang="ts">
import { createNamespace } from '@ll-plus/utils'
import { useAttrs } from 'vue'
import { segmentedProps } from './segmented'

defineOptions({ name: 'LlSegmented' })
const attrs = useAttrs()
const bem = createNamespace('segmented')

defineProps(segmentedProps)
</script>
